let login = {
    zhCN: "简体中文",
    title: 'User login',
    backLogin:"Back to login",
    loginText: "Login",
    pwdLogin: 'Password login',
    scanLogin: 'Scan login',
    usernamePlaceholder: 'Username/Email/Phone Number',
    usernamePlaceholderLdap: 'Username',
    passwordPlaceholder: 'Please enter password',
    ldapPlaceholder: 'Please enter password',
    authenticationMethod: 'Please choose one of the following authentication methods to log in',
    authenticationMethodss: 'Please choose one of the following authentication methods',
    otpPlaceholder: "Please enter the OTP dynamic password or click to push",
    fidoUaf: "You have selected UAF fingerprint/face authentication, please click the login button and open the Feitianyun signaling APP to complete the login!",
    fidoU2f: "You have selected the FIDO2 authentication method, please click the login button to complete the login!",
    forgetPwd: "Forget password?",
    accountPwdLogin: "Account password login",
    feiTianFastLogin:"You have selected Feitianyun signaling FastLogin authentication method, please click the login button to complete the login!",
    tempLoginPlaceholder: "Please enter a temporary authentication password",
    clickRefresh: "Click to refresh",
    codeTitle: "Use Feitianyun signaling to scan the code to log in",
    qrCodeSuccess: "Scan code successfully",
    confirmLogin: "Please confirm the login in Feitianyun Signaling",
    otherMethods: "Other methods",
    usernameMsg: "Please enter username/email/mobile number",
    onlyUsernameMsg: "Please enter user name",
    qrText: "The current QR code has expired",
    qrLoseEfficacy: "The current QR code has expired",
    dynamicPassword: "Please enter the dynamic password!",
    messageAuthenticationCode: "Please enter the SMS verification code!",
    emailCode: "Please enter the email verification code!",
    temporaryPwd: "Please enter a temporary authentication password!",
    loginSuccess: "Login successful",
    authSuccess:"Your identity authentication is successful!",
    canClose:"You can now close this browser tab.",
    clickDown:"Click the desktop software below to operate!",
    binding: {
        title: "Bind",
        text: "Users binding"
    },
    computationNum: {
        title: "Please complete security verification",
        result: "Please enter the result",
        resultErr: "The verification result cannot be empty!"
    },
    editPwd: {
        title: "Change Password",
    },
    retrieveEmail: {
        title: "Retrieve password",
        email: "Please input your email",
        emailMsg: "Please enter the correct email format",
        password: "New password",
        affirmPassword: "Confirm Password",
        verifyPassword:"The two passwords are different",
        back: "Back to login",
        goPhone: "Retrieve by phone number",
        newPwd: "New password cannot be empty",
        affirmMsg: "Confirm password can not be blank",
    },
    retrievePwd: {
        phone: "Please enter phone number",
        goEmail: "Retrieve by email",
        phoneErr: "The phone number format is incorrect, please re-enter"
    },
    subAccount: {
        title: "Application account selection\n",
        subtitle:'Please select an application account for single sign on',
        placeholder: "Please select a sub account",
        unuse:'This account has been disabled. Please contact your enterprise administrator to enable it!'
    },
    jiantou: "One click login with FT FastLogin",
    maybe: "Or",
    fastLogin: "You have selected the FastLogin authentication method, please click the login button to complete the login!",
    appLogin: "Use Feitian Cloudentify APP to scan and log in",
    idenAuth:"Please authenticate",
    cloundBind:"Bind on Feitian Yunxin FastLogin",
    scanSucc:"Scan code successfully",
    confirmL:"Please confirm the login in Feitianyun Signaling",
    sureConfirm:"Confirm",
    loginOutTime:"Login timed out, please log in again!",
    notSupportWeb:"This browser does not support web authentication!",
    supportSecurity:"Web authentication only supports secure connections",
    push:"Push",
    pwdNotEmpty:"Password can not be blank!",
    bind:"Bind",
    putPwd:"Please enter password",
    qyzx:'Enterprise information',
    jsyw:'Technical highlights'

}

export default login
